import React from 'react'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { SectionContainer, SectionContent } from 'builder/components/ProfileSummary/styles'
import {
  SectionHeader,
  SectionHeaderFoldableContainer,
  SectionHint,
  useFoldableSectionHandlers,
} from 'builder/components/Section'
import SectionTitle from 'builder/components/SectionTitle'
import { SectionNames } from 'builder/modules/resumeEditor'
import { getWorkExperienceSection } from '../ExpandableSections'
import { ExpandableSectionWrapper } from '../../ExpandableSectionWrapper'
import { useShokumuTranslations } from '../../useShokumuTranslations'

export const WorkExperience: React.FC = () => {
  const resume = useTypedSelector(state => state.resumeEditor.resume)
  const { i18n } = useShokumuTranslations()
  const title = i18n('work_experience.title')
  const hint = i18n('work_experience.hint')
  const { isOpened, handleToggle } = useFoldableSectionHandlers(SectionNames.workExperiences)

  return (
    <SectionContainer>
      <SectionHeader isOpened={isOpened} onClick={handleToggle}>
        <SectionTitle title={title} isOpened={isOpened} />
        <SectionHeaderFoldableContainer isOpened={isOpened}>
          <SectionHint>{hint}</SectionHint>
        </SectionHeaderFoldableContainer>
      </SectionHeader>

      <SectionContent>
        <ExpandableSectionWrapper sections={getWorkExperienceSection(resume)} isOpened={isOpened} />
      </SectionContent>
    </SectionContainer>
  )
}
